<script setup>
import InvoicingTable from '@frontJs/components/tables/projectManagement/apikom/InvoicingTable.vue';
import ServerTable from '@frontJs/components/tables/projectManagement/dev/ServerTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Facturation - Apikom - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Apikom - Facturation </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                content: h(InvoicingTable),
            },
            eCommerce: {
                title: 'E-commerce',
                content: h(InvoicingTable, {
                    type: 'e-commerce',
                }),
            },
            showcase: {
                title: 'Vitrine',
                content: h(InvoicingTable, {
                    type: 'showcase',
                }),
            },
            customMade: {
                title: 'Sur-mesure',
                content: h(InvoicingTable, {
                    type: 'custom-made',
                }),
            },
            servers: {
                title: 'Serveurs',
                content: h(ServerTable),
            },
        }"
    />
</template>
